import React, { useState, useEffect, useRef } from 'react';
import './room1.css';
import './room2.css';
import './room2task3.css'

import Settings from '../components/common/settings';
import Lost from '../components/common/lost';
import { useNavigate } from 'react-router-dom';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const TOTAL_TIME = 10 * 60;
const ROOM_KEY = 'room2_time'; 

const Room2task3 = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
  const [openSettings, setOpenSettings] = useState(false);
  const [showTapeIntro, setShowTapeIntro] = useState(true);
  const [showLosePopup, setShowLosePopup] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const lockedAudio = useRef(null);
  const settingsAudio = useRef(null);

  useEffect(() => {
    lockedAudio.current = new Audio(lockedSound);
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const saved = localStorage.getItem(ROOM_KEY);

      if (!saved) return;

      const elapsed = Math.floor(
        (Date.now() - Number(saved)) / 1000
      );

      const remaining = Math.max(
        TOTAL_TIME - elapsed,
        0
      );

      setTimeLeft(remaining);

      if (remaining === 0) {
        setShowLosePopup(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowTapeIntro(false);
    }, 3200);

    return () => clearTimeout(timeout);
  }, []);

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;

    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const handleDropOnClue = () => {
    setTimeout(() => {
      navigate('/Codevidlevel2');
    }, 500);
  };

  const minutes = String(
    Math.floor(timeLeft / 60)
  ).padStart(2, '0');

  const seconds = String(
    timeLeft % 60
  ).padStart(2, '0');

  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="room2div">
       
      <div className="inventorybar">
        <div
          className={`inventory-item magnify-icon ${
            isDragging ? 'dragging' : ''
          }`}
          draggable
          onDragStart={() => setIsDragging(true)}
          onDragEnd={() => setIsDragging(false)}
        />
      </div>

      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">
            TIME REMAINING
          </span>

          <div className="timerdiv">
            <span
              className={`timerdigits ${
                isWarning ? 'timerwarning' : ''
              }`}
            >
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning
                  ? '#ff4444'
                  : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div
          className="settings"
          onClick={openSettingsMenu}
        />
      </div>

      <div
        className="clueimage"
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDropOnClue}
      />

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem(
            ROOM_KEY
          );
          window.location.reload();
        }}
      />

    </section>
  );
};

export default Room2task3;